import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import Job from './job.jsx';
import JobsTableColumnToggler from './jobs-table-column-toggler.jsx';
import PortalJobScheduler from '../job-scheduling/portal-job-scheduler.jsx';
//import PortalJobUserTask from '../user-task/user-task-scheduler.jsx';
import RegNoteBox from './reg-note-box.jsx';
import moment from 'moment';
import DatePicker from 'react-datepicker';
export default class JobsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: props.jobs || [],
      isLoading: !props.jobs,
      url: props.url || null,
      error: false,
      hasMore: true,
      page: 1,
      hideJobsOn: false,
      hideJobsBy: false,
      hideJobsFrom: false,
      hideJobsQ: true,
      infiniteScroll: props.infiniteScroll || false,
      noCategoryLabels: props.noCategoryLabels  || false,
      play: false,
      driverScreen:props.driverScreen || false,
      jobIds:props.jobIds || [],
      seprateLoading:false,
      isZoneJobsLoading:false,
      firstSelectedZone:null,
      secondSelectedZone:null,
      firstZoneJobs:[],
      secondZoneJobs:[],
      totalSelectedZone:0,
      isQuickDriverPlannScreen:false,
      groupWorkScreen:props.groupWorkScreen || false,
      allOtherJobs:false,
      allJobsCurrentPage:1,
      firstZoneJobsCurrentPage:1,
      secondZoneJobsCurrentPage:1,
      zonePageSelectedJobToAddDriver:null,
      isZoneScreenActive:false,
      updatedCurrentJobDetails:null,
      showJobScheduler: false,
      isGroupWorkScreenListing:true,
      unplannedScreen:props.unplannedScreen || false,
      firstLookPage:props.firstLookPage || false,
      zonePageSelectedJobToAddRegNote:null,
      customerAllJobsPage:props.customerAllJobsPage || false,
      filterDate:moment().toDate(),
      isFilterJobByDateActive:false,
      deliveredScreen:props.deliveredScreen || false
    };
    /* add new job on group page */
    Echo.channel('jobs-table').
    listen('NewJob',(e) => {
        if((this.state.groupWorkScreen && this.state.isGroupWorkScreenListing) || (this.state.unplannedScreen)){
          this.setState({page:1},()=>{
            this.getJobs();
          });
        }
        if(this.state.groupWorkScreen && !this.state.isGroupWorkScreenListing){
         
          fetch('/api/v1/portal/jobs/view/' +e.jobid+'/'+this.state.groupWorkScreen, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              if(this.state.firstSelectedZone == response.data[0].zone_number){
                this.setState({
                  firstZoneJobs:[
                    ...this.state.firstZoneJobs,
                    ...response.data
                  ],
                });
              }
              if(this.state.secondSelectedZone == response.data[0].zone_number){
                this.setState({
                  secondZoneJobs:[
                    ...this.state.secondZoneJobs,
                    ...response.data
                  ],
                });
              }
              
            });
          });
        }
      }
    );
    /* add new job on group page */
    Echo.
      channel('group-planning-zonetable-update').
      listen('GroupPlanningZoneTableUpdate', (e) => {
        if(this.state.groupWorkScreen && this.state.isGroupWorkScreenListing){
          fetch('/api/v1/portal/jobs/view/' +e.jobId+'/'+this.state.groupWorkScreen, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              if(response.data[0].status == 'cancelled' || response.data[0].status == 'aborted' || response.data[0].status == 'deleted'){
                let Updateindex = this.state.jobs.findIndex(job => job.id == e.jobId);
                this.state.jobs.splice(Updateindex, 1);
                this.setState({jobs:this.state.jobs});
              }
            });
          });
          
        }
        
        if(this.state.groupWorkScreen && !this.state.isGroupWorkScreenListing){
          fetch('/api/v1/portal/jobs/view/' +e.jobId+'/'+this.state.groupWorkScreen, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({updatedCurrentJobDetails:response.data[0]},()=>{
                this.handleTableUpdateAfterSavedDriver(e.jobId);
              });
            });
          });
         
        }
    });
    Echo.channel('zone-company-update').listen('ZoneCompanyUpdate', (e) => {
      if(this.state.groupWorkScreen && !this.state.isGroupWorkScreenListing){
        this.handleTableUpdateAfterCompanyUpdate(e.jobId,e.selected_company);
      }
    });
    Echo.channel('zone-priority-update').listen('ZonePriorityUpdate', (e) => {
      if(this.state.groupWorkScreen && !this.state.isGroupWorkScreenListing){
        this.handleTableUpdateAfterPriorityUpdate(e.jobId,e.quick_prioritise);
      }
    });
    this.handleScroll = this.handleScroll.bind(this);
    this.handler = this.handler.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.handleFromFZonePageSchedulerHide = this.handleFromFZonePageSchedulerHide.bind(this);
    this.handleFromSZonePageSchedulerHide = this.handleFromSZonePageSchedulerHide.bind(this);
    this.handleHideRegNoteBox = this.handleHideRegNoteBox.bind(this);
    this.handleFilterDateSelection = this.handleFilterDateSelection.bind(this);
  }
  componentWillMount() {
    if (this.state.infiniteScroll === true) {
      window.addEventListener(
        'scroll',
        this.handleScroll
      );
    }
  }
  handleFilterDateSelection(date) {
      this.setState({filterDate: date,isFilterJobByDateActive:true,page:1,jobs:[],isLoading:true},()=>{
        this.getJobs();
      });
  }
  handleFilterClear(){
    let currentDate = moment().toDate();
    this.setState({filterDate: currentDate,isFilterJobByDateActive:false,page:1,jobs:[],isLoading:true,hasMore:true},()=>{
      this.getJobs();
    });
  }
  handler(someValue){
      this.setState({
        jobs: someValue
    });
  }
  handleLoading(someVal){
    this.setState({
        seprateLoading: someVal
    });
  }
  componentDidMount() {
    this.setState({
      uuid: this.makeUUID(),
      play: true,
      isNotSuperAdmin:$('#data-compnay-id').attr('data-not-super-admin')
    });
    if (this.state.isLoading === true) {
      this.getJobs();
    }
    $('[data-toggle="tooltip"]').tooltip(); 
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      jobs: nextProps.jobs,
      jobIds:nextProps.jobIds
    });
  }
  componentWillUnmount() {
    if (this.state.infiniteScroll === true) {
      window.removeEventListener(
        'scroll',
        this.handleScroll
      );
    }
  }
  getJobs() {
    if ((this.state.isLoading === true || this.state.groupWorkScreen || this.state.unplannedScreen || this.state.isFilterJobByDateActive) && this.state.url) {
      let filterDate =  moment(this.state.filterDate).format("YYYY-MM-DD");
      let geturl = this.state.url+'?page='+this.state.page;
      if( this.state.isFilterJobByDateActive){
        geturl = geturl+'&filterdate='+filterDate;
      }
      return fetch(
        geturl,
        {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token,
            "Accept": 'application/json'
          },
        }
      ).then((responseText) => {
        let response = responseText.json();

        response.then((nextJobs) => {
          if(nextJobs.data.length == 0){
            this.setState({hasMore: false});
          }
          this.setState({
            isLoading: false,
            jobs: [
              ...this.state.jobs,
              ...nextJobs.data,
            ],
            url: this.state.url,
            page: nextJobs.current_page+1
          });
        });
      });
    }
    return false;
  }
  makeUUID() {
    let date = new Date().getTime();
    if (typeof performance !== 'undefined' &&
      typeof performance.now === 'function') {
      date += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
      function (c) {
        let random = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (
          c === 'x' ?
            random :
            (random & 0x3 | 0x8)).toString(
          16
        );
      }
    );
  }
  handleScroll() {
    /*if ((window.innerHeight + document.documentElement.scrollTop
    ) === document.documentElement.offsetHeight) {*/
    if ((window.innerHeight + document.scrollingElement.scrollTop + 10
        ) >= document.documentElement.offsetHeight) {
    if(this.state.hasMore){
      this.setState({
        isLoading: true
      });
      this.getJobs();
      }
    }
  }
  handleZoneButtonClick(e){
    var currentElement = e.target;
    let zonenumber = currentElement.getAttribute('data-zone-number');
    if(this.state.allOtherJobs){
      this.setState({
        allOtherJobs:false,
        allJobsCurrentPage:1,
        firstZoneJobs:[],
        secondZoneJobs: [],
      });
    }
    this.setState({isZoneScreenActive:true,isGroupWorkScreenListing:false});
    if((this.state.totalSelectedZone < 3)){
      $(currentElement).toggleClass('selected');
        if($(currentElement).hasClass('selected')){
          if(this.state.firstSelectedZone == null){
              this.setState({firstSelectedZone: zonenumber},()=>{
                this.setState({totalSelectedZone: (this.state.totalSelectedZone + 1)},()=>{
                  this.handleFetchFirstZoneJobs();
                });
              });
              if(this.state.secondSelectedZone != null){
                for(var i=1;i<=15;i++){
                  if(!document.querySelector('.zone'+i).classList.contains("selected")){
                    document.querySelector('.zone'+i).style.opacity = '0.7';
                    document.querySelector('.zone'+i).disabled = true;
                  }
                }
              }
            }else{
              if(this.state.secondSelectedZone == null){
                this.setState({secondSelectedZone: zonenumber},()=>{
                  this.setState({totalSelectedZone: (this.state.totalSelectedZone + 1)},()=>{
                    this.handleFetchSecondZoneJobs();
                  });
                });
                for(var i=1;i<=15;i++){
                  if(!document.querySelector('.zone'+i).classList.contains("selected")){
                    document.querySelector('.zone'+i).style.opacity = '0.7';
                    document.querySelector('.zone'+i).disabled = true;
                  }
                }
              }else{
                  currentElement.disabled = false;
                  $(currentElement).removeClass('selected');
              }
            }
        }else{
          for(var i=1;i<=15;i++){
            if(document.querySelector('.zone'+i).disabled == true){
              document.querySelector('.zone'+i).disabled = false;
              document.querySelector('.zone'+i).style.opacity = '1';
            }
          }
          this.setState({totalSelectedZone: (this.state.totalSelectedZone - 1)});
          if(this.state.firstSelectedZone == zonenumber){
            this.setState({firstSelectedZone: null,firstZoneJobs:[],firstZoneJobsCurrentPage:1})
          }
          if(this.state.secondSelectedZone == zonenumber){
            this.setState({secondSelectedZone: null,secondZoneJobs:[],secondZoneJobsCurrentPage:1})
          }
        }
    }
    
  }
  handleFetchFirstZoneJobs(isReverseSetToDropoffLocation = false){
    let selectedFZone = this.state.firstSelectedZone;
    if(this.state.firstZoneJobs.length < 0 || this.state.secondZoneJobs.length < 0){
      this.setState({isZoneJobsLoading:true});
    }
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/'+selectedFZone+'?page='+this.state.firstZoneJobsCurrentPage;
    if(isReverseSetToDropoffLocation){
       url = url+'&revers=true';
    }
    //let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/'+selectedFZone+'?page='+this.state.firstZoneJobsCurrentPage;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {
       
        if(nextJobs.length == 0){
          this.setState({firstZoneJobs:this.state.firstZoneJobs,isZoneJobsLoading:false,isReverseBYDropoffSet:false});
          if(isReverseSetToDropoffLocation){
            this.setState({firstZoneJobs:[]});
            // $('#infomodallabel').html('Not Found');
            // $('#infomodal .modal-body').html('');
            // $('#infomodal .modal-body').html('No By Dropoff jobs found for zone '+selectedFZone+'..');
            // $('#infomodal').modal();
          }
        }
        if(nextJobs.length > 0){
          if(isReverseSetToDropoffLocation){
            this.setState({
              isZoneJobsLoading: false,
              firstZoneJobs: nextJobs,
              firstZoneJobsCurrentPage: 1,
              isReverseBYDropoffSet:false
            });
          }else{
            this.setState({
              isZoneJobsLoading: false,
              firstZoneJobs: [
                ...this.state.firstZoneJobs,
                ...nextJobs,
              ],
              firstZoneJobsCurrentPage: 1
            });
          }
          
        }
        $('[data-toggle="tooltip"]').tooltip(); 
      });
    });
  }
  handleFetchSecondZoneJobs(isReverseSetToDropoffLocation = false){
    let selectedSZone = this.state.secondSelectedZone;
    if(this.state.firstZoneJobs.length < 0 || this.state.secondZoneJobs.length < 0){
      this.setState({isZoneJobsLoading:true});
    }
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/'+selectedSZone+'?page='+this.state.secondZoneJobsCurrentPage;
    if(isReverseSetToDropoffLocation){
        url = url+'&revers=true';
    }
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {

        if(nextJobs.length == 0){
          this.setState({secondZoneJobs:this.state.secondZoneJobs,isZoneJobsLoading:false});
          if(isReverseSetToDropoffLocation){
            this.setState({secondZoneJobs:[]});
            // $('#infomodallabel').html('Not Found');
            // $('#infomodal .modal-body').html('');
            // $('#infomodal .modal-body').html($('#infomodal .modal-body').html()+'<br>No By Dropoff jobs found for zone '+selectedSZone+'..');
            // $('#infomodal').modal();
          }
        }
        if(nextJobs.length > 0){
          if(isReverseSetToDropoffLocation){
            this.setState({
              isZoneJobsLoading: false,
              secondZoneJobs: nextJobs,
              secondZoneJobsCurrentPage: 1
            });
          }else{
            this.setState({
              isZoneJobsLoading: false,
              secondZoneJobs: [
                ...this.state.secondZoneJobs,
                ...nextJobs,
              ],
              secondZoneJobsCurrentPage: 1
            });
          }
        }
        
        $('[data-toggle="tooltip"]').tooltip(); 
      });
    });
  }
  handleAllOtherJobsClick(e){
    this.setState({isZoneScreenActive:true,isGroupWorkScreenListing:false});
    if(this.state.allJobsCurrentPage < 2 && (this.state.firstSelectedZone != null || this.state.secondSelectedZone != null)){
      /* clean up zone button and zoen filtered jobs */
      this.setState({
        firstSelectedZone:null,
        secondSelectedZone:null,
        firstZoneJobs:[],
        secondZoneJobs: [],
        totalSelectedZone:0,
        firstZoneJobsCurrentPage:1,
        secondZoneJobsCurrentPage:1
      });
      if(this.state.allJobsCurrentPage == 1){
        this.setState({isZoneJobsLoading:true});
      }
      var btns = document.getElementsByClassName('zone-btn');
      for(var i = 0; i < btns.length; i++) {
        btns[i].disabled = false;
        btns[i].style.opacity = '1';
        if($(btns).hasClass('selected')){
          $(btns).removeClass('selected');
        }
      }
    }
     /* clean up zone button and zoen filtered jobs */
    //this.setState({isZoneJobsLoading:true});
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/all'+'?page='+this.state.allJobsCurrentPage;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {
        if(nextJobs.length == 0){
          console.log('no more jobs');
          // if(document.querySelector('.load-more-all-btn')){
          //   document.querySelector('.load-more-all-btn').innerText = 'No more jobs found..';
          // }
        }
        if(nextJobs.length > 0){
          // if(document.querySelector('.load-more-all-btn')){
          //   document.querySelector('.load-more-all-btn').innerText = 'Load more Jobs';
          // }
          this.setState({
            //isZoneJobsLoading: false,
            allOtherJobs:true,
            isZoneJobsLoading:false,
            firstZoneJobs: [
              ...this.state.firstZoneJobs,
              ...nextJobs,
            ],
            allJobsCurrentPage: nextJobs.current_page+1
          });
          if(this.state.allJobsCurrentPage > 2){
            var elmnt = document.querySelector('.load-more-all-btn');
            elmnt.scrollIntoView();
          }
        }
        $('[data-toggle="tooltip"]').tooltip(); 
      });
    });
  }
  
  handleReverseToDropoffLocationList(e){
    this.setState({isReverseBYDropoffSet:true});
      $(e.target).attr('disabled','disabled');
      this.handleFetchFirstZoneJobs(true);
      this.handleFetchSecondZoneJobs(true);
      $('.revers-to-dropoff-location .btn').removeAttr('disabled');
  }

  resetZoneJobs(e){
    this.setState({
      firstSelectedZone:null,
      secondSelectedZone:null,
      firstZoneJobs:[],
      secondZoneJobs: [],
      allOtherJobs:false,
      totalSelectedZone:0,
      allJobsCurrentPage:1,
      firstZoneJobsCurrentPage:1,
      secondZoneJobsCurrentPage:1,
      isZoneScreenActive:false,
      isGroupWorkScreenListing:true
    });
    var btns = document.getElementsByClassName('zone-btn');
    for(var i = 0; i < btns.length; i++) {
      btns[i].disabled = false;
      btns[i].style.opacity = '1';
      if($(btns).hasClass('selected')){
        $(btns).removeClass('selected');
      }
    }
  }
  handleQuickPlanFromZoneButtonClick(e,currentJobId) {
    this.setState({showJobScheduler: true,isQuickDriverPlannScreen:true,zonePageSelectedJobToAddDriver:currentJobId});
    
    $('#'+currentJobId+'-add-driver').toggleClass('toggle-hide');
  }
  handleRegButtonClick(e,currentJobId) {
    this.setState({zonePageSelectedJobToAddRegNote:currentJobId});
    $('#'+currentJobId+'-add-reg-note').toggleClass('toggle-hide');
  }
  handleHideRegNoteBox(){
    $('#'+this.state.zonePageSelectedJobToAddRegNote+'-add-reg-note').toggleClass('toggle-hide');
  }
  handleSetCompanyForPlanning(e,currentJobId){
    let that = this;
    $.ajax({
      url: "/api/v1/portal/jobs/set-planner-company/"+currentJobId,
      data: { 
        api_token: window.api_token,
        selected_company: e.target.value
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      //
    });
  }
  handleSetQuickPrioritiseJob(e,currentJobId){
    let that = this;
    $.ajax({
      url: "/api/v1/portal/jobs/set-quick-prioritise-job/"+currentJobId,
      data: {
        api_token: window.api_token,
        quick_prioritise: e.target.value
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      //
    });
  }
  handleTableUpdateAfterCompanyUpdate(currentJobId,selected_company){
    let UpdateJobFindex = this.state.firstZoneJobs.findIndex(job => job.id == currentJobId);
    let UpdateJobSindex = this.state.secondZoneJobs.findIndex(job => job.id == currentJobId);
    if(UpdateJobFindex != -1){
      this.state.firstZoneJobs[UpdateJobFindex].selected_company = selected_company;
      this.setState({firstZoneJobs:this.state.firstZoneJobs});
    }
    if(UpdateJobSindex != -1){
      this.state.secondZoneJobs[UpdateJobSindex].selected_company = selected_company;
      this.setState({secondZoneJobs:this.state.secondZoneJobs});
    }
  }
  handleTableUpdateAfterPriorityUpdate(currentJobId,quick_prioritise){
    let UpdateJobFindex = this.state.firstZoneJobs.findIndex(job => job.id == currentJobId);
    let UpdateJobSindex = this.state.secondZoneJobs.findIndex(job => job.id == currentJobId);
    if(UpdateJobFindex != -1){
      this.state.firstZoneJobs[UpdateJobFindex].quick_prioritise = quick_prioritise;
      this.setState({firstZoneJobs:this.state.firstZoneJobs});
    }
    if(UpdateJobSindex != -1){
      this.state.secondZoneJobs[UpdateJobSindex].quick_prioritise = quick_prioritise;
      this.setState({secondZoneJobs:this.state.secondZoneJobs});
    }
  }
  handleFromFZonePageSchedulerHide(){
  this.setState({showJobScheduler: false});
    $('#'+this.state.zonePageSelectedJobToAddDriver+'-add-driver').toggleClass('toggle-hide');
  }
  handleFromSZonePageSchedulerHide(){
  this.setState({showJobScheduler: false});
    $('#'+this.state.zonePageSelectedJobToAddDriver+'-add-driver').toggleClass('toggle-hide');
  }
  
  handleTableUpdateAfterSavedDriver(updateJobId){
    $('#'+this.state.zonePageSelectedJobToAddDriver+'-add-driver').addClass('toggle-hide');
    let UpdateJobFindex = this.state.firstZoneJobs.findIndex(job => job.id == updateJobId);
    let UpdateJobSindex = this.state.secondZoneJobs.findIndex(job => job.id == updateJobId);
    
    // added second line if inside if to restrict multiple subbed or to subbed same company multiple 
    if(UpdateJobFindex != -1){
      if((this.state.updatedCurrentJobDetails.driver_id !== null && this.state.updatedCurrentJobDetails.driver !== null) ||
      (this.state.updatedCurrentJobDetails.original_company_id !== null && 
        this.state.updatedCurrentJobDetails.subcontracted_to_company_id !== null &&
        (this.state.updatedCurrentJobDetails.original_company_id === this.state.updatedCurrentJobDetails.subcontracted_to_company_id)) ||
      ((this.state.updatedCurrentJobDetails.original_company_id !== this.state.updatedCurrentJobDetails.subcontracted_by_company_id)) || 
      (this.state.updatedCurrentJobDetails.status == 'cancelled') ||
      (this.state.updatedCurrentJobDetails.status == 'deleted') ||
      (this.state.updatedCurrentJobDetails.status == 'aborted')){
        this.state.firstZoneJobs.splice(UpdateJobFindex, 1);
        this.setState({firstZoneJobs:this.state.firstZoneJobs});
      }else{
        this.state.firstZoneJobs.splice(UpdateJobFindex, 1, this.state.updatedCurrentJobDetails);
        this.setState({firstZoneJobs:this.state.firstZoneJobs});
        if(!this.state.zonePageSelectedJobToAddRegNote){
          this.refs.child.handleParentUpdatedJob(this.state.updatedCurrentJobDetails);
        }
      }
    }
    if(UpdateJobSindex != -1){
      if((this.state.updatedCurrentJobDetails.driver_id !== null && this.state.updatedCurrentJobDetails.driver !== null) ||
      (this.state.updatedCurrentJobDetails.original_company_id !== null && 
        this.state.updatedCurrentJobDetails.subcontracted_to_company_id !== null &&
        (this.state.updatedCurrentJobDetails.original_company_id === this.state.updatedCurrentJobDetails.subcontracted_to_company_id)) ||
      ((this.state.updatedCurrentJobDetails.original_company_id !== this.state.updatedCurrentJobDetails.subcontracted_by_company_id)) || 
      (this.state.updatedCurrentJobDetails.status == 'cancelled') ||
      (this.state.updatedCurrentJobDetails.status == 'deleted') ||
      (this.state.updatedCurrentJobDetails.status == 'aborted')){
        this.state.secondZoneJobs.splice(UpdateJobSindex, 1);
        this.setState({secondZoneJobs:this.state.secondZoneJobs});
      }else{
        this.state.secondZoneJobs.splice(UpdateJobSindex, 1, this.state.updatedCurrentJobDetails);
        this.setState({secondZoneJobs:this.state.secondZoneJobs});
        if(!this.state.zonePageSelectedJobToAddRegNote){
          this.refs.child.handleParentUpdatedJob(this.state.updatedCurrentJobDetails);
        }
      }
    }
  }
  
  render() {
    let driverScreen = this.state.driverScreen;
    let groupWorkScreen = this.state.groupWorkScreen;
    let firstLookPage = this.state.firstLookPage;
    let handlerFunc = this.handler;
    let handleLoadingFunc = this.handleLoading;
    let jobIds = this.state.jobIds;
    let uuid = this.state.uuid;
    let apiUrl = this.state.url;
    let JobsBy = [], JobsOn = [], JobsFrom = [], JobsQ = [], displayedJobs = [],GDateBy = [],GDateOn=[],GDateFrom=[],GDateQ=[];
    if (this.state.jobs && this.state.jobs.length > 0) {
     
      // this loop puts the jobs in groups of dropoff preposition,
      //  prioritising scheduled over requested,
      //   showing requested only if no value for scheduled.
      let indexCounter = 0;
      let unplannedScreenFlag = (this.state.unplannedScreen) ? true : (groupWorkScreen) ? true : false;
      let unplannedScreen = this.state.unplannedScreen;
      let globalDate = "";
      if(!this.state.customerAllJobsPage){
        this.state.jobs.forEach(function(i,index) {
          let isDiffDate = false;
          
          if(unplannedScreenFlag){
            if ((i.dropoff_preposition === 'by') && (!displayedJobs[i.id])) {
              if(GDateBy.indexOf(i.required_dropoff_date) == -1){
                globalDate = "";
              }
              if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                globalDate = i.required_dropoff_date;
                isDiffDate = true;
                GDateBy[i.id] = globalDate;
              }
            JobsBy.push(
              <Job
                key={'job-'+i.id}
                data={i}
                url={apiUrl}
                driverScreen={driverScreen}
                jobIndex={indexCounter}
                handler={handlerFunc}
                handleLoading={handleLoadingFunc}
                jobIds={jobIds}
                isDiffDate={isDiffDate}
                groupWorkScreen={groupWorkScreen}
                firstLookPage={firstLookPage}
                unplannedScreen={unplannedScreen}
              />
            );
            displayedJobs[i.id] = i.id;
            indexCounter++;
            }
            if ((i.dropoff_preposition === 'on') && (!displayedJobs[i.id])) {
                if(GDateOn.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                } 
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateOn[i.id] = globalDate;
                }
              JobsOn.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.dropoff_preposition === 'from') && (!displayedJobs[i.id])) {
                if(GDateFrom.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateFrom[i.id] = globalDate;
                }
              JobsFrom.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.dropoff_preposition === '?') && (!displayedJobs[i.id])) {
                if(GDateQ.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateQ[i.id] = globalDate;
                }
              JobsQ.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === 'by') && (!displayedJobs[i.id])) {
              if(GDateBy.indexOf(i.required_dropoff_date) == -1){
                globalDate = "";
              }
              if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                globalDate = i.required_dropoff_date;
                isDiffDate = true;
                GDateBy[i.id] = globalDate;
              }
              JobsBy.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}       
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === 'on') && (!displayedJobs[i.id])) {
                
                if(GDateOn.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }     
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateOn[i.id] = globalDate;
                }
              JobsOn.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === 'from') && (!displayedJobs[i.id])) {
                if(GDateFrom.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateFrom[i.id] = globalDate;
                }
              JobsFrom.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === '?') && (!displayedJobs[i.id])) {
                if(GDateQ.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateQ[i.id] = globalDate;
                }
              JobsQ.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
          }else{
            if ((i.scheduled_dropoff_preposition === 'by') && (!displayedJobs[i.id])) {
              if(GDateBy.indexOf(i.required_dropoff_date) == -1){
                globalDate = "";
              }
              if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                globalDate = i.required_dropoff_date;
                isDiffDate = true;
                GDateBy[i.id] = globalDate;
              }
              JobsBy.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}       
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === 'on') && (!displayedJobs[i.id])) {
                
                if(GDateOn.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }     
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateOn[i.id] = globalDate;
                }
              JobsOn.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === 'from') && (!displayedJobs[i.id])) {
                if(GDateFrom.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateFrom[i.id] = globalDate;
                }
              JobsFrom.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.scheduled_dropoff_preposition === '?') && (!displayedJobs[i.id])) {
                if(GDateQ.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateQ[i.id] = globalDate;
                }
              JobsQ.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}       
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.dropoff_preposition === 'by') && (!displayedJobs[i.id])) {
              if(GDateBy.indexOf(i.required_dropoff_date) == -1){
                globalDate = "";
              }
              if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                globalDate = i.required_dropoff_date;
                isDiffDate = true;
                GDateBy[i.id] = globalDate;
              }
            JobsBy.push(
              <Job
                key={'job-'+i.id}
                data={i}
                url={apiUrl}
                driverScreen={driverScreen}
                jobIndex={indexCounter}
                handler={handlerFunc}
                handleLoading={handleLoadingFunc}
                jobIds={jobIds}
                isDiffDate={isDiffDate}
                groupWorkScreen={groupWorkScreen}
                firstLookPage={firstLookPage}   
                unplannedScreen={unplannedScreen}
              />
            );
            displayedJobs[i.id] = i.id;
            indexCounter++;
            }
            if ((i.dropoff_preposition === 'on') && (!displayedJobs[i.id])) {
                if(GDateOn.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                } 
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateOn[i.id] = globalDate;
                }
              JobsOn.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}   
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.dropoff_preposition === 'from') && (!displayedJobs[i.id])) {
                if(GDateFrom.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateFrom[i.id] = globalDate;
                }
              JobsFrom.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}   
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
            if ((i.dropoff_preposition === '?') && (!displayedJobs[i.id])) {
                if(GDateQ.indexOf(i.required_dropoff_date) == -1){
                  globalDate = "";
                }
                if(globalDate != i.required_dropoff_date && unplannedScreenFlag == true){
                  globalDate = i.required_dropoff_date;
                  isDiffDate = true;
                  GDateQ[i.id] = globalDate;
                }
              JobsQ.push(
                <Job
                  key={'job-'+i.id}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}        
                  unplannedScreen={unplannedScreen}
                />
              );
              displayedJobs[i.id] = i.id;
              indexCounter++;
            }
          }
          
        });
      }
      if(this.state.customerAllJobsPage){
        let isDiffDate = false;
        let customerAllJobsPage = this.state.customerAllJobsPage;
        this.state.jobs.forEach(function(i,index) {
          JobsBy.push(
              <Job
                  key={'job-'+i.id+'-'+index}
                  data={i}
                  url={apiUrl}
                  driverScreen={driverScreen}
                  jobIndex={indexCounter}
                  handler={handlerFunc}
                  handleLoading={handleLoadingFunc}
                  jobIds={jobIds}
                  isDiffDate={isDiffDate}
                  groupWorkScreen={groupWorkScreen}
                  firstLookPage={firstLookPage}       
                  unplannedScreen={unplannedScreen}
                  customerAllJobsPage={customerAllJobsPage}
                />
          );
        });
      }
      
    }
    let firstZoneJobs = [];
    let secondZoneJobs = [];
    let loggedInCompany = $('#data-compnay-id').attr('data-compnay-id');
    if(this.state.firstZoneJobs.length > 0){
      this.state.firstZoneJobs.map((currentJob, index) => {
        let joburl = "/jobs/view/"+currentJob.id;
        let jobDShowHideId=index+'-'+currentJob.id;
        let allowOrDisallowDriverButton = (currentJob.company_id != loggedInCompany) ? true  :false;
        let isJobSubbedcontratced = (currentJob.subcontracted_by_company_id != null && currentJob.subcontracted_to_company_id != null && currentJob.original_company_id  != null) ? true  :false;
        let clsName = "alert alert-danger not-planned-quick-plan-button";
        let clsDName = "jobs-table-row-driver-name pencilled-in-driver";
        if(isJobSubbedcontratced){
          clsName += " driver-box-orange-subbedoutjob";
          clsDName += " driver-box-orange-subbedoutjob";
        }
        let unUsualTime = ['?','am','pm','anytime','asap'];
        let turnsJobToRedDG = false;
        let requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
        if(requiredDropoffDateG != "" || requiredDropoffDateG != null || requiredDropoffDateG != "?-?-?"){
          if(unUsualTime.indexOf(currentJob.dropoff_time) != -1){
            let now = moment();
            requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
          }else{
            let now = moment();
            requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
            if(turnsJobToRedDG){
              turnsJobToRedDG =( (currentJob.dropoff_time) < (now.format('HHmm') )) ? true : turnsJobToRedDG;
            }
          }
        }
        let clsname = '';
        if((turnsJobToRedDG)){
          clsname += ' past-job-not-collected-blue';
        }
        if((currentJob.company_id == 2 && currentJob.dropoff_preposition == 'on')){
          clsname += ' sccd-by-jobs';
        }
        firstZoneJobs.push(
              <tr key={index} className={clsname}>
                  <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                  <td>{currentJob.company.short_name}</td>
                  <td>{currentJob.pickup_day}/{currentJob.pickup_month}/{currentJob.pickup_year} {currentJob.pickup_time.toUpperCase()}</td>
                  <td>{currentJob.dropoff_day}/{currentJob.dropoff_month}/{currentJob.dropoff_year} {currentJob.dropoff_time.toUpperCase()}</td>  
                  <td data-toggle="tooltip" data-placement="right" data-original-title={currentJob.reg_note} className={(currentJob.reg_note) ? "user-click-event yellow-bg" : "user-click-event"}>
                    <span onClick={(e) => this.handleRegButtonClick(e,jobDShowHideId)}>
                      {currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}
                    </span>
                  </td>
                  <td>{currentJob.customer.name}</td> 
                  <td>{currentJob.pickup_address.town_city}</td> 
                  <td>{currentJob.pickup_address.postcode}</td> 
                  <td>{currentJob.dropoff_address.town_city}</td> 
                  <td>{currentJob.dropoff_address.postcode}</td>
                  <td>{(currentJob.driver === null && currentJob.saved_driver === null && !currentJob.has_split_jobs) ?
                        <span
                          className={(allowOrDisallowDriverButton) ? clsName+' disable_pointer_event':clsName}
                          onClick={(e) => this.handleQuickPlanFromZoneButtonClick(e,jobDShowHideId)} 
                          disabled={allowOrDisallowDriverButton}
                        >
                          No Driver <i className="fa fa-exclamation">&nbsp;</i>
                        </span> : (currentJob.saved_driver && currentJob.saved_driver.user) ?
                        <span className={(allowOrDisallowDriverButton) ? clsDName : clsDName+" planned-job-driver"}
                              onClick={(e) => this.handleQuickPlanFromZoneButtonClick(e,jobDShowHideId)}>
                          {(currentJob.saved_driver.user.first_name + ' ' +currentJob.saved_driver.user.last_name)}
                        </span> : null}
                  </td> 
                  <td>
                    <select className="form-control form-control" value={currentJob.selected_company} onChange={(e) => this.handleSetCompanyForPlanning(e,currentJob.id)}>
                      <option value="-">-</option>
                      <option value="acv">ACV</option>
                      <option value="bvl">BVL</option>
                      <option value="cnd">CND</option>
                      <option value="g4">G4</option>
                      <option value="sccd">SCCD</option>
                    </select>  
                  </td>
                  <td>
                    <select className={(currentJob.quick_prioritise == "priority") ? "form-control form-control quick-prioritise-dropdown mark-green" :"form-control form-control quick-prioritise-dropdown"} 
                      value={currentJob.quick_prioritise} 
                      onChange={(e) => this.handleSetQuickPrioritiseJob(e,currentJob.id)}>
                      <option value="-">-</option>
                      <option value="priority">Priority</option>
                    </select>
                  </td>
              </tr>
        );
        if(allowOrDisallowDriverButton == false){
          
            firstZoneJobs.push(
              <tr id={jobDShowHideId+'-add-driver'} className="toggle-hide" key={index+'-'+currentJob.id}><td colSpan="13">
                <PortalJobScheduler
                                jobId={currentJob.id}
                                data={currentJob}
                                isLoading={false}
                                schedulerHide={this.handleFromFZonePageSchedulerHide}
                                hasAssignedDriver={(currentJob.saved_driver !== null && !currentJob.has_split_jobs) ? true : false}
                                isQuickDriverPlannScreen={(currentJob.saved_driver === null) ? false : true}
                                isQuickDriverPlannScreenClick={this.handleFromFZonePageSchedulerHide}
                                isZonePage={true}
                                ref="child"
                              />
                              </td>
              </tr>
            );
          
        }
        firstZoneJobs.push(
          <tr id={jobDShowHideId+'-add-reg-note'} className="toggle-hide" key={index+'-'+currentJob.id+'-reg-note'}>
            <td colSpan="13">
              <RegNoteBox
                  jobId={currentJob.id}
                  data={currentJob}
                  handleHideRegNoteBox={this.handleHideRegNoteBox}
              />
            </td>
          </tr>
        );
      });
    }else{
      firstZoneJobs.push(
          <tr key='no-records'><td colSpan="13" className='text-center'>No Records</td></tr>
      );
    }
    if(this.state.secondZoneJobs.length > 0){
      this.state.secondZoneJobs.map((currentJob, index) => {
        let joburl = "/jobs/view/"+currentJob.id;
        let jobDShowHideId=index+'-'+currentJob.id;
        let allowOrDisallowDriverButton = (currentJob.company_id != loggedInCompany) ? true  :false;
        let isJobSubbedcontratced = (currentJob.subcontracted_by_company_id != null && currentJob.subcontracted_to_company_id != null && currentJob.original_company_id  != null) ? true  :false;
        let clsName = "alert alert-danger not-planned-quick-plan-button";
        let clsDName = "jobs-table-row-driver-name pencilled-in-driver";
        if(isJobSubbedcontratced){
          clsName += " driver-box-orange-subbedoutjob";
          clsDName += " driver-box-orange-subbedoutjob";
        }
        let unUsualTime = ['?','am','pm','anytime','asap'];
        let turnsJobToRedDG = false;
        let requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
        if(requiredDropoffDateG != "" || requiredDropoffDateG != null || requiredDropoffDateG != "?-?-?"){
          if(unUsualTime.indexOf(currentJob.dropoff_time) != -1){
            let now = moment();
            requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
          }else{
            let now = moment();
            requiredDropoffDateG = currentJob.dropoff_year+'-'+currentJob.dropoff_month+'-'+currentJob.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
            if(turnsJobToRedDG){
              turnsJobToRedDG =( (currentJob.dropoff_time) < (now.format('HHmm') )) ? true : turnsJobToRedDG;
            }
          }
        }
        let clsname = '';
        if((turnsJobToRedDG)){
          clsname += ' past-job-not-collected-blue';
        }
        if((currentJob.company_id == 2 && currentJob.dropoff_preposition == 'on')){
          clsname += ' sccd-by-jobs';
        }
        secondZoneJobs.push(
          <tr key={index} className={clsname}>
                  <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                  <td>{currentJob.company.short_name}</td>
                  <td>{currentJob.pickup_day}/{currentJob.pickup_month}/{currentJob.pickup_year} {currentJob.pickup_time.toUpperCase()}</td> 
                  <td>{currentJob.dropoff_day}/{currentJob.dropoff_month}/{currentJob.dropoff_year} {currentJob.dropoff_time.toUpperCase()}</td>  
                  <td data-toggle="tooltip" data-placement="right" data-original-title={currentJob.reg_note} className={(currentJob.reg_note) ? "user-click-event yellow-bg" : "user-click-event"}>
                    <span onClick={(e) => this.handleRegButtonClick(e,jobDShowHideId)}>
                      {currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}
                    </span>
                  </td>
                  <td>{currentJob.customer.name}</td> 
                  <td>{currentJob.pickup_address.town_city}</td> 
                  <td>{currentJob.pickup_address.postcode}</td> 
                  <td>{currentJob.dropoff_address.town_city}</td> 
                  <td>{currentJob.dropoff_address.postcode}</td>
                  <td>{(currentJob.driver === null && currentJob.saved_driver === null && !currentJob.has_split_jobs) ?
                        <span
                          className={(allowOrDisallowDriverButton) ? clsName+' disable_pointer_event': clsName}
                          onClick={(e) => this.handleQuickPlanFromZoneButtonClick(e,jobDShowHideId)} 
                          disabled={allowOrDisallowDriverButton}
                        >
                          No Driver <i className="fa fa-exclamation">&nbsp;</i>
                        </span> : (currentJob.saved_driver && currentJob.saved_driver.user) ?
                        <span className={(allowOrDisallowDriverButton) ? clsDName : clsDName+" planned-job-driver"}
                              onClick={(e) => this.handleQuickPlanFromZoneButtonClick(e,jobDShowHideId)}>
                          {(currentJob.saved_driver.user.first_name + ' ' +currentJob.saved_driver.user.last_name)}
                        </span> : null}
                  </td>
                  <td>
                    <select className="form-control form-control" value={currentJob.selected_company} onChange={(e) => this.handleSetCompanyForPlanning(e,currentJob.id)}>
                      <option value="-">-</option>
                      <option value="acv">ACV</option>
                      <option value="bvl">BVL</option>
                      <option value="cnd">CND</option>
                      <option value="g4">G4</option>
                      <option value="sccd">SCCD</option>
                    </select>  
                  </td> 
                  <td>
                    <select className={(currentJob.quick_prioritise == "priority") ? "form-control form-control quick-prioritise-dropdown mark-green" :"form-control form-control quick-prioritise-dropdown"} 
                      value={currentJob.quick_prioritise} 
                      onChange={(e) => this.handleSetQuickPrioritiseJob(e,currentJob.id)}>
                      <option value="-">-</option>
                      <option value="priority">Priority</option>
                    </select>
                  </td>
              </tr>
        );
        if(allowOrDisallowDriverButton == false){
          secondZoneJobs.push(
            <tr id={jobDShowHideId+'-add-driver'} className="toggle-hide" key={index+'-'+currentJob.id}><td colSpan="13">
              <PortalJobScheduler
                              jobId={currentJob.id}
                              data={currentJob}
                              isLoading={true}
                              schedulerHide={this.handleFromSZonePageSchedulerHide}
                              hasAssignedDriver={(currentJob.saved_driver !== null && !currentJob.has_split_jobs) ? true : false}
                              isQuickDriverPlannScreen={(currentJob.saved_driver === null) ? false : true}
                              isQuickDriverPlannScreenClick={this.handleFromSZonePageSchedulerHide}
                              isZonePage={true}
                              ref="child"
                            />
                            </td>
            </tr>
          );
        }
        secondZoneJobs.push(
          <tr id={jobDShowHideId+'-add-reg-note'} className="toggle-hide" key={index+'-'+currentJob.id+'-reg-note'}>
            <td colSpan="13">
              <RegNoteBox
                  jobId={currentJob.id}
                  data={currentJob}
                  handleHideRegNoteBox={this.handleHideRegNoteBox}
              />
            </td>
          </tr>
        );
      });
    }else{
      secondZoneJobs.push(
          <tr key='no-records'><td colSpan="13" className='text-center'>No Records</td></tr>
      );
    }
    return (
      <>
        { groupWorkScreen ? 
        <div className="zone-jobs-container">
            <div className="row align-cenetered">
              <div className="col-md-3">
                <img src="/images/Map-New.jpg" className="img-responsive"/>
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-2">
                      <button className="alert alert-info zone-btn zone1 btn-lg" data-zone-number="1" onClick={(e) => this.handleZoneButtonClick(e)}>
      
                      </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone2 btn-lg" data-zone-number="2" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone3 btn-lg" data-zone-number="3" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone4 btn-lg" data-zone-number="4" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone5 btn-lg" data-zone-number="5" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                      <button className="alert alert-info zone-btn zone6 btn-lg" data-zone-number="6" onClick={(e) => this.handleZoneButtonClick(e)}>
      
                      </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone7 btn-lg" data-zone-number="7" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone8 btn-lg" data-zone-number="8" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone9 btn-lg" data-zone-number="9" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone10 btn-lg" data-zone-number="10" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                      <button className="alert alert-info zone-btn zone11 btn-lg" data-zone-number="11" onClick={(e) => this.handleZoneButtonClick(e)}>

                      </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone12 btn-lg" data-zone-number="12" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone13 btn-lg" data-zone-number="13" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone14 btn-lg" data-zone-number="14" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone15  btn-lg" data-zone-number="15" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zoneOther btn-lg" onClick={(e) => this.handleAllOtherJobsClick(e)}></button>
                  </div>
                </div>
              </div>
            </div>
        </div> : '' }
        {/* {(this.state.isZoneJobsLoading) ?
          <div className="text-center">
            <h1>
              <i className="fa fa-spinner fa-pulse"></i>
            </h1>
          </div>
          :
          null
        } */}
        {(this.state.isZoneScreenActive) ? 
            <div className="row">
              <div className="col-md-12 text-center"><a className="btn btn-link back-to-job-listing" onClick={(e) => this.resetZoneJobs(e)}><i className="fa fa-arrow-left"></i>  Back to job listing</a></div>
            </div>
        : null}
        { (this.state.isZoneScreenActive) ? 
          <div className="row">
              
              <div className={(this.state.allOtherJobs) ? 'col-md-12' : 'col-md-12'}>
                <div className='text-center revers-to-dropoff-location'>
                  <button className="btn btn-primary btn-lg"
                  onClick={(e)=>this.handleReverseToDropoffLocationList(e)}>
                    By Drop Off
                    </button>&nbsp;&nbsp;
                  {this.state.isReverseBYDropoffSet ?
                    <i className="fa fa-spinner fa-pulse"></i>
                    : ''
                  }
                </div>
                { this.state.allOtherJobs ? 
                  <h2 className="text-center">All Jobs</h2> :
                  <h2 className="text-center">ZONE {this.state.firstSelectedZone}</h2>
                }
                
                <table className="table table-bordered black-bordered-table">
                  <thead>
                    <tr>
                      <th>Job Number</th>
                      <th>Company</th>
                      <th>Required Pickup</th>
                      <th>Required Dropoff</th>
                      <th>Reg</th>
                      <th>Customer</th>
                      <th>Pickup Town/city</th>
                      <th>Pickup Postcode</th>
                      <th>Dropoff Town/city</th>
                      <th>Dropoff Postcode</th>
                      <th>Driver</th>
                      <th>Selected Company</th>
                      <th>Priority</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.firstZoneJobs.length < 0) ? 
                    (<tr><td colSpan="13"><span className="add-loading-text">
                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                        firstZoneJobs
                  }
                  </tbody>
                </table>
                {/* { !this.state.allOtherJobs ? 
                  <button className="alert alert-success btn-block load-more-first-btn" title="Load more jobs" onClick={(e) => this.handleFetchFirstZoneJobs(e)}>Load more</button>
                :''}
                { this.state.allOtherJobs ?
                  <button className="alert alert-success btn-block load-more-all-btn" title="Load more jobs" onClick={(e) => this.handleAllOtherJobsClick(e)}>Load more Jobs</button>
                :''} */}
                
                <br/>
              </div>
              { !this.state.allOtherJobs ?
                <div className="col-md-12">
                  <h2 className="text-center">ZONE {this.state.secondSelectedZone}</h2>
                  <table className="table table-bordered black-bordered-table">
                      <thead>
                        <tr>
                        <th>Job Number</th>
                        <th>Company</th>
                        <th>Required Pickup</th>
                        <th>Required Dropoff</th>
                        <th>Reg</th>
                        <th>Customer</th>
                        <th>Pickup Town/city</th>
                        <th>Pickup Postcode</th>
                        <th>Dropoff Town/city</th>
                        <th>Dropoff Postcode</th>
                        <th>Driver</th>
                        <th>Selected Company</th>
                        <th>Priority</th>
                        </tr>
                      </thead>
                      <tbody>
                      {(this.state.secondZoneJobs.length < 0) ? 
                          (<tr><td colSpan="13"><span className="add-loading-text">
                                  <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                          secondZoneJobs
                        }
                      </tbody>
                    </table>
                    {/* { !this.state.allOtherJobs ? 
                      <button className="alert alert-success btn-block load-more-second-btn" title="Load more jobs" onClick={(e) => this.handleFetchSecondZoneJobs(e)}>Load more</button>
                    :''} */}
                    <br/>
                </div> : '' 
              }
          </div>
         : null
        }
        {(!this.state.isZoneScreenActive) ? 
          <div className={"jobs-table is-notsuperadmin-"+ this.state.isNotSuperAdmin} key={uuid+'-table'}>
            {this.state.seprateLoading ?
              <div className="seprate-loading text-center">
                <h1><i className="fa fa-spinner fa-pulse"></i></h1>
              </div>
              :
              ''
            }
          <JobsTableColumnToggler />
          <Animate play={this.state.play} start={{opacity: 0}} end={{opacity: 1}} key={uuid+'-animate'}>
          { !groupWorkScreen ? 
            (!firstLookPage) ? 
            (!this.state.customerAllJobsPage) ?
            <div className="jobs-table-row header jobs-table-header-row">
            { this.state.driverScreen ?
                <div className="cell column-type-order">
                  MOVE
                </div> : ''
            }
            <div className="cell column-type-job-number">
              Job Number
            </div>
            <div className="cell column-type-assigned-to">
              Assigned to
            </div>
            <div className="cell column-type-company">
              Company
            </div>
            <div className="cell column-type-original-company">
              Original Company
            </div>
            <div className="cell column-type-subcontracted-by-company">
              Subcontracted By
            </div>
            <div className="cell column-type-subcontracted-to-company">
              Subcontracted To
            </div>
            <div className="cell column-type-required-pickup">
              Required Pickup
            </div>
            <div className="cell column-type-required-dropoff">
              Required Dropoff
            </div>
            <div className="cell column-type-scheduled-pickup">
              Scheduled Pickup
            </div>
            <div className="cell column-type-scheduled-dropoff">
              Scheduled Dropoff
            </div>
            { (this.state.firstLookPage || this.state.unplannedScreen) ? 
              <div className="cell column-quick-prioritise">
                Prioritise
              </div>
            : ""}
            <div className="cell column-type-reg">
              Reg
            </div>
            <div className="cell column-type-vehicle-on-site">
              Vehicle On Site
            </div>
            <div className="cell column-type-customer">
              Customer
            </div>
            <div className="cell column-type-customer-job-number">
              Customer Job Number
            </div>
            <div className="cell column-type-pickup-from">
              Pickup From
            </div>
            <div className="cell column-type-pickup-town-city">
              Pickup Town/City
            </div>
            <div className="cell column-type-pickup-postcode">
              Pickup Postcode
            </div>
            <div className="cell column-type-dropoff-to">
              Dropoff To
            </div>
            <div className="cell column-type-dropoff-town-city">
              Dropoff Town/City
            </div>
            <div className="cell column-type-dropoff-postcode">
              Dropoff Postcode
            </div>
            <div className="cell column-type-driver">
              Driver
            </div>
            <div className="cell column-type-status">
              Driver Status
            </div>
            <div className="cell column-type-distance-in-miles">
              Miles
            </div>
            <div className="cell column-type-estimated-duration">
              Estimated Duration
            </div>
            <div className="cell column-type-job-price">
              Job Price
            </div>
            <div className="cell column-type-driver-price">
              Driver Price
            </div>
            <div className="cell column-type-expenses-price">
              Expenses Price
            </div>
            <div className="cell column-type-admin-fee">
              Admin Fee
            </div>
            <div className="cell column-type-g4-profit">
              Profit
            </div>
            <div className="cell column-type-gross-profit-percentage">
              Gross Profit (%)
            </div>
            <div className="cell column-type-invoice-month">
              Invoice Month
            </div>
            <div className="cell column-type-invoice-number">
              Invoice Number
            </div>
            <div className="cell column-type-subcontract-invoice-number">
              Subcontract Invoice Number
            </div>
            <div className="cell column-type-driver-delivered-date">
              Driver Delivered Date
            </div>
            <div className="cell column-type-confirmed_on_site">
              Confirmed on site
            </div>
            <div className="cell column-type-full-details">
              &nbsp;
            </div>
          </div>
          :""
          : ""
          :''}
          { this.state.customerAllJobsPage ?  
            <div className="jobs-table-row header jobs-table-header-row">
            <div className="cell column-type-job-number">
              Job Number
            </div>
            {/* <div className="cell column-type-customer">
              Customer
            </div> */}
            <div className="cell column-type-scheduled-pickup">
              Scheduled Pickup
            </div>
            <div className="cell column-type-scheduled-dropoff">
              Scheduled Dropoff
            </div>
            <div className="cell column-type-reg">
              Reg
            </div>
            <div className="cell column-type-pickup-from">
              Pickup From
            </div>
            <div className="cell column-type-dropoff-to">
              Dropoff To
            </div>
            <div className="cell column-type-status">
              Driver Status
            </div>
            <div className="cell column-type-job-price">
              Job Price
            </div>
            <div className="cell column-type-expenses-price">
              Expenses Price
            </div>
            <div className="cell column-type-full-details">
              &nbsp;
            </div>
          </div> : ""
          }
          </Animate>
          {(this.state.deliveredScreen) ? 
            <div className="col-md-12 text-center mrgn-btm filter-date-section">
              <label>Filter by delivered date :</label> &nbsp;&nbsp;
              <DatePicker todayButton={"Today"} 
                dateFormat="dd/MM/yyyy" 
                onChange={this.handleFilterDateSelection} 
                selected={this.state.filterDate}/>&nbsp;&nbsp;
                {(this.state.isFilterJobByDateActive) ?
                  <a onClick={(e)=>this.handleFilterClear(e)}>Clear Filter &nbsp;<i className="fa fa-sync font-16"></i></a> : ''
                }
            </div>
          : ""}
          {(JobsBy.length > 0 && !this.state.groupWorkScreen) ?
            [
              <div
                className="jobs-table-divider-heading"
                key={"jobs-table-subtitle-by-"+uuid}
                style={{
                  display: (
                    this.state.noCategoryLabels === true ?
                      'none' :
                      'block'
                  )
                }}
              >
                DROPOFFS BY
              </div>
            ].concat(
              <div
                key={'jobs-table-all-jobs-by-'+uuid}
              >
                {JobsBy}
              </div>
            )
            : null
          }
          {(JobsOn.length > 0) ?
            [
              <div
                className="jobs-table-divider-heading"
                key={"jobs-table-subtitle-on-"+uuid}
                style={{
                  display: (
                    this.state.noCategoryLabels === true ?
                      'none' :
                      'block'
                  )
                }}
              >
                DROPOFFS ON
              </div>
            ].concat(
              <div
                key={'jobs-table-all-jobs-on-'+uuid}
              >
                {JobsOn}
              </div>
            )
            : null
          }
          {(JobsFrom.length > 0) ?
            [
              <div
                className="jobs-table-divider-heading"
                key={"jobs-table-subtitle-from-"+uuid}
                style={{
                  display: (
                    this.state.noCategoryLabels === true ?
                      'none' :
                      'block'
                  )
                }}
              >
                DROPOFFS FROM
              </div>
            ].concat(
              <div
                key={'jobs-table-all-from-'+uuid}
              >
                {JobsFrom}
              </div>
            )
            : null
          }
          {(JobsQ.length > 0) ?
            [
              <div
                className="jobs-table-divider-heading"
                key={"jobs-table-subtitle-q-"+uuid}
                style={{
                  display: (
                    this.state.noCategoryLabels === true ?
                      'none' :
                      'block'
                  )
                }}
                >
                {(!this.state.firstLookPage) ? 'DROPOFFS ?' : ''}
              </div>
            ].concat(
              <div
                key={"jobs-table-all-q-"+uuid}
              >
                {JobsQ}
              </div>
            )
            : null
          }
        </div>
        : null}
        {(this.state.isLoading) ?
          <div className="text-center">
            <h1>
              <i className="fa fa-spinner fa-pulse"></i>
            </h1>
          </div>
          :
          null
        }{(this.state.hasMore) ?
          null
          :
          <div className="text-center no-more">
            <h1>
              No more jobs.
            </h1>
          </div>
        }
        </>
    );
  }
}
